var e = "down", t = (t, n, r) => {
	if (!n || !r) return;
	let i = n.clientHeight, a = n.scrollTop, o = r.clientHeight, s = r.offsetTop, c = s + o, l = a + i;
	switch (t) {
		case "up":
			s < a && (n.scrollTop = s - 4);
			break;
		case e: c > l && (n.scrollTop = c - i + 4);
	}
};
//#endregion
export { e as DOWN, t as scrollItemIntoView };

//# sourceMappingURL=scrollItemIntoView.js.map